import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { msalLogin, logOut } from 'utils/authService';
import { msalConfig, loginRequest } from 'config';
import IdleWrapper from 'components/IdleWrapper';
import Loading from 'components/Loading';
import { useCurrentUser } from 'hooks';
import path from 'common/path';

export const msalInstance = new PublicClientApplication(msalConfig);

const Authentication: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    loading: userLoading,
    user,
    isAuthenticated,
    logoutRedirect,
  } = useCurrentUser();

  const navigate = useNavigate();
  const [tokenLoading, setTokenLoading] = useState(true);

  const getMsalUserData = async () => {
    try {
      await msalInstance.initialize();

      const data = await msalInstance.acquireTokenSilent({
        account: user,
        ...loginRequest,
      });

      msalLogin(data?.accessToken);
      setTokenLoading(false);
    } catch (e) {
      logoutRedirect();
      logOut();
      setTokenLoading(false);
      navigate(path.login);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      getMsalUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated && !userLoading) {
      setTokenLoading(false);
    }
  }, [isAuthenticated, userLoading]);

  if (userLoading || tokenLoading) {
    return <Loading />;
  }

  return <>{children}</>;
};

const AuthWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <Authentication>
        <IdleWrapper>{children}</IdleWrapper>
      </Authentication>
    </MsalProvider>
  );
};

export default AuthWrapper;
